import { useAuthStore } from "@src/stores/auth";
import { useChatSessionStore } from "@src/stores/chatSession";
import { useMessageStore } from "@src/stores/messages";
import { db } from "@src/services/db";
import "@src/services/echo";

type SessionTransferredCleanupPayload = {
    session_id: number;
};

export const SessionTransferredCleanupListener = () => {
    const auth = useAuthStore();
    const sessionStore = useChatSessionStore();
    const messageStore = useMessageStore();

    const companyId = Number((auth.user as any)?.company_id ?? 0);
    if (!companyId) return;

    // @ts-ignore
    window.websockets
        .private(`company.${companyId}`)
        .listen(".SessionTransferredCleanupEvent", async (event: SessionTransferredCleanupPayload) => {
            try {
                const sessionId = Number(event?.session_id);
                if (!sessionId) return;

                await db.sessions.delete(sessionId).catch(() => {});

                if (Number((sessionStore.selectedSession as any)?.id) === sessionId) {
                    sessionStore.clearSession();
                    messageStore.clearBotState?.();
                }
            } catch (e) {
                console.error("❌ erro SessionTransferredCleanupEvent listener", e);
            }
        });
};